export const FEATURE_PREFIX_SEPARATOR = ':'
